import styled from "styled-components"

import Shadow from "../../images/sombra@2x.png"
import Check from "../../images/checked-gray.svg"

export const SectionWrapper = styled.div`
  margin: 0 auto;
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 80px 10px;
  box-sizing: border-box;

  @media screen and (min-width: 1100px) {
    flex-direction: row;
    padding: 120px 10px;
    justify-content: space-between;
  }
`

export const DetailList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
`

export const DetailListItem = styled.li`
  padding: 0 20px;
  font-size: 16px;
  margin-bottom: 20px;
  text-align: center;
  line-height: 28px;
  font-family: "Montserrat", sans-serif;
  position: relative;

  &:last-child {
    margin-bottom: 0;
  }

  @media screen and (min-width: 1100px) {
    text-align: left;
    font-size: 22px;
    padding: 0 0 0 40px;
    line-height: 32px;

    &:before {
      content: "";
      background-image: url(${Check});
      background-repeat: no-repeat;
      display: inline-block;
      width: 28px;
      height: 28px;
      position: absolute;
      left: 0;
      top: 4px;
    }
  }
`

export const SectionImageBase = styled.img`
  width: 100%;
`

export const SectionImageBox = styled.div`
  position: relative;
  margin-bottom: 30px;
  padding: 0 30px;
  z-index: 3;

  ${SectionImageBase} {
    position: relative;
    z-index: 3;
  }

  &:after {
    background-image: url(${Shadow});
    content: "";
    width: 100%;
    height: 100px;
    position: absolute;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    bottom: -60px;
    left: 0px;
    z-index: 1;
  }

  @media screen and (min-width: 1100px) {
    padding: 0;
  }
`

export const SectionImage = styled(SectionImageBase)`
  box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.1);

  @media screen and (min-width: 1100px) {
    width: 622px;
  }
`

export const SectionTitleBase = styled.h3`
  font-family: "Montserrat", sans-serif;
  position: relative;
  font-size: 24px;
  line-height: 30px;
  margin: 0;
  padding: 0 0 30px 0;
  font-weight: normal;

  &:after {
    content: "";
    height: 4px;
    width: 120px;
    display: inline-block;
    background-color: #00c6c7;
    position: absolute;
    left: 0;
    bottom: 15px;

    @media screen and (min-width: 1100px) {
      height: 7px;
    }
  }
`

export const SectionTitleMobile = styled(SectionTitleBase)`
  text-align: center;
  margin: 0 0 20px 0;

  &:after {
    left: 50%;
    bottom: 15px;
    transform: translate(-50%);
  }

  @media screen and (min-width: 1100px) {
    display: none;
  }
`

export const SectionTitleDesktop = styled(SectionTitleBase)`
  display: none;
  font-size: 40px;
  line-height: 50px;
  margin-bottom: 30px;

  &:after {
    bottom: 0;
  }

  @media screen and (min-width: 1100px) {
    display: block;
  }
`

export const SectionTitle = styled(SectionTitleBase)`
  text-align: center;

  &:after {
    background-color: #fff;
    left: 50%;
    bottom: 15px;
    transform: translate(-50%);
  }

  @media screen and (min-width: 1100px) {
    text-align: left;
    display: block;
    font-size: 40px;
    line-height: 50px;
    margin-bottom: 30px;

    &:after {
      bottom: 0;
      left: 0;
      position: absolute;
      transform: none;
    }
  }
`

export const SectionTitleCenter = styled(SectionTitleBase)`
  text-align: center;
  line-height: 40px;

  &:after {
    left: 50%;
    bottom: 15px;
    transform: translate(-50%);
  }

  @media screen and (min-width: 1100px) {
    font-size: 40px;
    line-height: 50px;
    margin-bottom: 30px;

    &:after {
      bottom: 0;
    }
  }
`

// Provider styles
export const SectionDivisor = styled.div`
  @media screen and (min-width: 1100px) {
    flex-basis: 380px;
  }
`
